var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageAdd02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0005 6.74997C22.4147 6.74997 22.7505 6.41418 22.7505 5.99997C22.7505 5.58576 22.4147 5.24997 22.0005 5.24997V6.74997ZM14.0005 5.24997C13.5863 5.24997 13.2505 5.58576 13.2505 5.99997C13.2505 6.41418 13.5863 6.74997 14.0005 6.74997V5.24997ZM18.7505 1.99997C18.7505 1.58576 18.4147 1.24997 18.0005 1.24997C17.5863 1.24997 17.2505 1.58576 17.2505 1.99997H18.7505ZM17.2505 9.99997C17.2505 10.4142 17.5863 10.75 18.0005 10.75C18.4147 10.75 18.7505 10.4142 18.7505 9.99997H17.2505ZM22.0005 5.24997H18.0005V6.74997H22.0005V5.24997ZM18.0005 5.24997H14.0005V6.74997H18.0005V5.24997ZM17.2505 1.99997V5.99997H18.7505V1.99997H17.2505ZM17.2505 5.99997V9.99997H18.7505V5.99997H17.2505Z",
    fill: "#D5D7E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5005 2.99994C7.02215 2.99994 4.78297 2.99994 3.39173 4.39118C2.00049 5.78242 2.00049 8.0216 2.00049 12.4999C2.00049 16.9783 2.00049 19.2175 3.39173 20.6087C4.78297 21.9999 7.02215 21.9999 11.5005 21.9999C15.9788 21.9999 18.218 21.9999 19.6092 20.6087C21.0005 19.2175 21.0005 16.9783 21.0005 12.4999V11.9999",
    stroke: "#D5D7E2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00049 14.1354C2.61951 14.0455 3.24533 14.0011 3.8722 14.0026C6.52414 13.9466 9.11113 14.7729 11.1716 16.3342C13.0825 17.7821 14.4252 19.7748 15.0005 22",
    stroke: "#D5D7E2",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.8962C19.8246 16.3008 18.6088 15.9988 17.3862 16C15.5345 15.9927 13.7015 16.6733 12 18",
    stroke: "#D5D7E2",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageAdd02);
export default __webpack_public_path__ + "static/media/image-add-02.4e00245c0af81a6d7c78086d936922ec.svg";
export { ForwardRef as ReactComponent };